module.exports = __webpack_public_path__ + "admin/img/card_icon_visa.86cd88a3.svg";